import type {
    ExportTransactionsRequest,
    TransactionDetailsRequest,
    TransactionsRequest,
} from '@/types/api/transactions';

type TransactionsApi = {
    list: TransactionsRequest['url'];
    details(id: string): TransactionDetailsRequest['url'];
    export: ExportTransactionsRequest['url'];
};

export const transactionsApi: TransactionsApi = {
    list: 'transactions',
    details: (id: string) => `transactions/${id}`,
    export: 'transactions/export',
};
